import axios, { AxiosResponse } from 'axios';
import { setTokens } from 'src/backoffice-app-code/features/Auth/applications/localStorages/tokenLocalStorage';
import { UpdatePasswordFormData } from '../../models/UpdatePasswordFormData';
import { AuthUserDTO, userDTOFromToken } from '../DTOs/AuthUserDTO';
import { BaseUserDTO } from '../DTOs/UserDTO';

const tokenUrl = `${process.env.REACT_APP_TOKEN_URL}`;
const baseUrl = `${process.env.REACT_APP_LOYALTY_API}`;

const GetUser = async (): Promise<BaseUserDTO | undefined> => {
  const response: AxiosResponse<BaseUserDTO> = await axios.get(`${baseUrl}/User/GetUserByToken`);

  return response.data;
};

const Login = async (email: string, password: string): Promise<AuthUserDTO | undefined> => {
  const params = new URLSearchParams();
  params.append('client_id', 'loyalty-api');
  params.append('grant_type', 'password');
  params.append('scope', 'loyalty-api-scope');
  params.append('username', email);
  params.append('password', password);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  const response = await axios.post(tokenUrl, params, config);
  //set tokens
  setTokens({
    access_token: response.data.access_token,
    refresh_token: response.data.refresh_token,
  });
  const userDTO = userDTOFromToken(response.data.access_token);
  return { ...userDTO };
};

const Register = async (email: string, password: string): Promise<AuthUserDTO | undefined> =>
  undefined;

const ChangePassword = async (data: UpdatePasswordFormData): Promise<void> => {
  const response = await axios.put(`${baseUrl}/User/UpdatePassword`, data);
  return response.data;
};

export const AuthRepository = {
  GetUser,
  Login,
  Register,
  ChangePassword,
};
